import React from 'react'
import st from './CardDeal.module.scss'

const CardDeal = ({
  name,
  deal_status,
  styleClass,
  colorText,
  colorInf,
  translate,
}) => {
  return (
    <div className={`${st.deals} ${styleClass}`}>
      <div className={`${st.statusDealName}  ${colorInf}`}>{name}</div>
      <div className={st.rowInf}>
        <div className={st.columnSt}>
          <div className={`${st.textName} ${colorText}`}>
            {translate.quantity}
          </div>
          <div className={`${st.textNum}  ${colorInf}`}>
            {Object.keys(deal_status)?.length === 0 ||
            deal_status?.deal_count === null
              ? 0
              : deal_status?.deal_count.toLocaleString('ru-RU')}
          </div>
        </div>
        <div className={st.columnSt}>
          <div className={`${st.textName} ${colorText}`}>{translate.sum}</div>
          <div className={`${st.textNum}  ${colorInf}`}>
            {Object.keys(deal_status)?.length === 0 ||
            deal_status?.budget === null
              ? 0
              : deal_status?.budget.toLocaleString('ru-RU')}
            ₸
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardDeal
